import { useState } from 'react';
import { ISelectedTable } from '../../redux/_Dataset/types';
import { RootState } from '../../redux';
import { useSelector } from 'react-redux';
import MoreVertSharpIcon from '@mui/icons-material/MoreVertSharp';
import { Menu, MenuItem, Tooltip } from '@mui/material';
import { useDispatch } from 'react-redux';
import { SetSelectedTables } from '../../redux/_Dataset/dataset.action';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import SampleRecordPopUp from './SampleRecordPopUp';
import { fontSize } from '../..';
import ConfirmDialog from './ConfirmDialog';
interface IQueryTable {
  table: ISelectedTable;
  canEdit: boolean;
  onEdit: (table: ISelectedTable) => void;
  onDelete: (table: ISelectedTable) => void;
  vendor: string;
}

function QueryTable({ table, onEdit, canEdit, onDelete, vendor }: IQueryTable) {
  const selectedTables = useSelector((state: RootState) => state.dataset.selectedTables);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [rename, setRename] = useState({
    isRenaming: false,
    name: table.table,
  });
  const [hover, setHover] = useState(false);
  const [showTableData, setShowTableData] = useState(false);
  const [open, setOpen] = useState<boolean>(false);
  const dispatch = useDispatch();
  const options = ['Rename', 'Delete', 'Edit'] as const;
  const handleOptionClick = (option: 'Rename' | 'Delete' | 'Edit') => {
    if (!canEdit) return;
    if (option === 'Delete') {
      if (!table.isNewTable) {
        setOpen(true)
        return
      }
      dispatch(SetSelectedTables([...selectedTables.filter((_table) => _table.id !== table.id)]));
      onDelete(table);
    } else if (option === 'Edit') onEdit(table);
    else
      setRename({
        ...rename,
        isRenaming: true,
      });
    setAnchorEl(null);
  };
  const handleRename = () => {
    // const duplicate=selectedTables.findIndex(table)
    dispatch(
      SetSelectedTables([
        ...selectedTables.map((_table) =>
          _table.id === table.id ? { ..._table, table: rename.name, alias: rename.name } : _table,
        ),
      ]),
    );
    setRename({
      ...rename,
      isRenaming: false,
    });
  };
  return (
    <div
      onMouseOver={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      key={table.id}
      style={{
        display: 'flex',
        position: 'relative',
        borderRadius: '2px',
        boxShadow: hover ? '0 0 2px 2px #c9c9c9' : 'none',
        alignItems: 'center',
        overflow: 'hidden',
        marginBottom: 8,
      }}
    >
      <div
        style={{
          cursor: 'pointer',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        <MoreVertSharpIcon />
      </div>
      <div
      style={{width : "100%"}}
      >
        {rename.isRenaming ? (
          <input
           style={{
              width: "100%"
           }}
            type="text"
            value={rename.name}
            onChange={(e) => {
              setRename({
                name: e.target.value,
                isRenaming: true,
              });
            }}
            onBlur={handleRename}
          />
        ) : (
          <span
            className="ellipsis tableName"
            style={{
              fontSize: fontSize.medium,
              width: '10rem',
              display: 'inline-flex',
              flex: 'none',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
            }}
          >
            {table.table}
          </span>
        )}
      </div>

      {hover && !rename.isRenaming ? (
        <Tooltip
          title={<span style={{ fontSize: '12px' }}>View table</span>}
          arrow
          placement="right-start"
          style={{ float: 'right' }}
          sx={{ fontSize: '12px' }}
        >
          <VisibilityOutlinedIcon
            className="tableIcon"
            style={{
              position: 'absolute',
              right: '0.2rem',
              width: '1rem',
              height: '1rem',
              cursor: 'pointer',
            }}
            onClick={() => {
              setShowTableData(true);
            }}
          />
        </Tooltip>
      ) : null}
      {showTableData && (
        <SampleRecordPopUp
          open={showTableData}
          onClose={() => {
            setShowTableData(false);
            setHover(false);
          }}
          database={table.database}
          schema={table.schema}
          vendor={vendor}
          recordCount={100}
          workspaceId=""
          connectionId={table.connectionId}
          tablename={table.table}
          flatfileId={table.isFlatFile ? table.flatFileId : null}
          customQuery={table?.customQuery ?? null}
        />
      )}

      <Menu anchorEl={anchorEl} open={!!anchorEl} onClose={() => {
        setAnchorEl(null)
        setHover(false)
      }}>
        {options.map((option, idx) => (
          <MenuItem onClick={() => {
            handleOptionClick(option)
            setAnchorEl(null)
            setHover(false)
          }}>{option}</MenuItem>
        ))}
      </Menu>

      <ConfirmDialog
        open={open}
        title="Remove Table?"
        message="Removing this table may cause issues in the dependant playbooks of this dataset. Are you sure?"
        confirmText="Remove Table"
        cancelText="Cancel"
        onConfirm={() => {
          dispatch(SetSelectedTables([...selectedTables.filter((_table) => _table.id !== table.id)]));
          onDelete(table);
          setOpen(false)
          setHover(false)
        }}
        onCancel={() => {
          setOpen(false)
          setHover(false)
        }}
      />
    </div>
  );
}
export default QueryTable;
